import React from 'react'
import StatisticCard from './StatisticCard'
import useTotalReviewProgress from '../../../../components/assignment-header/question-progress/useTotalReviewProgress'

const ReviewedStatisticCard = () => {
    const { total, reviewed, isLoading, error } = useTotalReviewProgress()

    const getAdditionalContent = () => {
        if (total === 0) return ["Ready to start! 🚀"]
        
        const percentage = (reviewed / total) * 100
        
        if (percentage === 0) {
            return ["Just getting started 🚀"]
        } else if (percentage <= 25) {
            return ["Building momentum 📈"]
        } else if (percentage <= 50) {
            return ["Making solid progress 💪"]
        } else if (percentage <= 75) {
            return ["You're on track 🎯"]
        } else if (percentage <= 90) {
            return ["Almost there! 🔥"]
        } else {
            return ["Excellent work! 🎉"]
        }
    }

    return (
        <StatisticCard
            title="Reviewed"
            value={reviewed}
            suffix={`/ ${total}`}
            //trend={`${percentage}%`} to be added later
            trendType="success"
            additionalContent={getAdditionalContent()}
            loading={isLoading}
            error={error}
            dataTestReviewed="dashboard-reviewed-count"
            dataTestTotal="dashboard-total-count"
          />
    )
}

export default ReviewedStatisticCard